<template>
  <div class="row mb-3 g-2 align-items-end">

    <div class="col">
      <BaseMultiselectFilter :model-value="props.selectedRegional"
        @update:model-value="$emit('update:selectedRegional', $event)" :options="props.regionalsOptions"
        :loading="props.loadingRegionals" placeholder="Regionales" />
    </div>

    <div class="col-12 col-md-4 col-lg">
      <BaseMultiselectFilter :model-value="props.selectedProvince"
        @update:model-value="$emit('update:selectedProvince', $event)" :options="props.provincesOptions"
        :loading="props.loadingProvinces" placeholder="Provincias" />
    </div>

    <div class="col-12 col-md-4 col-lg">
      <BaseMultiselectFilter :model-value="props.selectedLocality"
        @update:model-value="$emit('update:selectedLocality', $event)" :options="props.localitiesOptions"
        :loading="props.loadingLocalities" placeholder="Localidades" group-values="items"
        group-label="province_group_label" />
    </div>

    <div class="col-12 col-md-4 col-lg">
      <BaseMultiselectFilter :model-value="props.selectedBrand"
        @update:model-value="$emit('update:selectedBrand', $event)" :options="props.brandsOptions"
        :loading="props.loadingBrands" placeholder="Marcas" label-key="name" />
    </div>

    <div class="col-12 col-md-4 col-lg">
      <BaseMultiselectFilter :model-value="props.selectedEconomicGroup"
        @update:model-value="$emit('update:selectedEconomicGroup', $event)" :options="props.economicGroupsOptions"
        :loading="props.loadingEconomicGroups" placeholder="Grupos Ec." />
    </div>
    <div class="col-12 col-md-auto" v-if="hasActiveFilters">
      <button @click="$emit('reset-filters')" class="btn btn-outline-danger" data-bs-toggle="tooltip"
        data-bs-placement="top" title="Limpiar todos los filtros"
        style="height: 41px; width: 41px; display: flex; align-items: center; justify-content: center;">
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>


  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import BaseMultiselectFilter from "@/components/ui/BaseMultiselectFilter.vue";

const props = defineProps({
  selectedProvince: { type: Array, default: () => [] },
  provincesOptions: { type: Array, default: () => [] },
  loadingProvinces: Boolean,

  selectedLocality: { type: Array, default: () => [] },
  localitiesOptions: { type: Array, default: () => [] },
  loadingLocalities: Boolean,

  selectedRegional: { type: Array, default: () => [] },
  regionalsOptions: { type: Array, default: () => [] },
  loadingRegionals: Boolean,

  selectedBrand: { type: Array, default: () => [] },
  brandsOptions: { type: Array, default: () => [] },
  loadingBrands: Boolean,

  selectedEconomicGroup: { type: Array, default: () => [] },
  economicGroupsOptions: { type: Array, default: () => [] },
  loadingEconomicGroups: Boolean,
});

defineEmits([
  'update:selectedProvince',
  'update:selectedLocality',
  'update:selectedRegional',
  'update:selectedBrand',
  'update:selectedEconomicGroup',
  'reset-filters'
]);

const hasActiveFilters = computed(() => {
  return (
    props.selectedProvince.length > 0 ||
    props.selectedLocality.length > 0 ||
    props.selectedRegional.length > 0 ||
    props.selectedBrand.length > 0 ||
    props.selectedEconomicGroup.length > 0
  );
});
</script>